import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VaStatementOfTruth } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  fullNameReducer,
  statementOfTruthFullName,
  statementOfTruthBodyElement,
} from '~/platform/forms/components/review/PreSubmitSection';
import { setPreSubmit as setPreSubmitAction } from 'platform/forms-system/src/js/actions';
import { isMinimalHeaderApp } from 'platform/forms-system/src/js/patterns/minimal-header';

const PreSubmitInfo = ({
  formData = {},
  preSubmitInfo,
  showError,
  setPreSubmit,
  user,
}) => {
  const { statementOfTruth = {} } = preSubmitInfo;
  const [
    statementOfTruthSignatureBlurred,
    setStatementOfTruthSignatureBlurred,
  ] = useState(false);

  const expectedFullName = statementOfTruthFullName(
    formData,
    statementOfTruth,
    user?.profile?.userFullName,
  );
  // Prefill the signature field once on mount if empty
  useEffect(() => {
    if (!formData.statementOfTruthSignature && expectedFullName) {
      setPreSubmit('statementOfTruthSignature', expectedFullName);
    }
  }, [expectedFullName, formData.statementOfTruthSignature, setPreSubmit]);

  return (
    <VaStatementOfTruth
      data-dd-privacy="mask"
      heading={statementOfTruth.heading || 'Statement of truth'}
      headingLevel={isMinimalHeaderApp() ? 2 : 3}
      inputLabel={statementOfTruth.textInputLabel || 'Your full name'}
      inputValue={formData.statementOfTruthSignature}
      inputMessageAriaDescribedby={`${
        statementOfTruth.heading || 'Statement of truth'
      }: ${statementOfTruth.messageAriaDescribedby}`}
      inputError={
        (showError || statementOfTruthSignatureBlurred) &&
        fullNameReducer(formData.statementOfTruthSignature) !==
          fullNameReducer(expectedFullName)
          ? `Please enter your name exactly as it appears on your application: ${expectedFullName}`
          : undefined
      }
      checked={formData.statementOfTruthCertified}
      onVaInputChange={event =>
        setPreSubmit('statementOfTruthSignature', event.detail.value)
      }
      onVaInputBlur={() => setStatementOfTruthSignatureBlurred(true)}
      onVaCheckboxChange={event =>
        setPreSubmit('statementOfTruthCertified', event.detail.checked)
      }
      checkboxError={
        showError && !formData.statementOfTruthCertified
          ? 'You must certify by checking the box'
          : undefined
      }
    >
      {statementOfTruthBodyElement(formData, statementOfTruth.body)}
    </VaStatementOfTruth>
  );
};

PreSubmitInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  preSubmitInfo: PropTypes.shape({
    statementOfTruth: PropTypes.shape({
      heading: PropTypes.string,
      textInputLabel: PropTypes.string,
      messageAriaDescribedby: PropTypes.string,
      body: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      fullNamePath: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      useProfileFullName: PropTypes.bool,
    }),
  }).isRequired,
  setPreSubmit: PropTypes.func.isRequired,
  showError: PropTypes.bool,
  user: PropTypes.shape({
    profile: PropTypes.shape({
      userFullName: PropTypes.shape({
        first: PropTypes.string,
        middle: PropTypes.string,
        last: PropTypes.string,
      }),
    }),
  }),
};

export default connect(
  state => ({
    formData: state.form?.data,
    user: state.user,
  }),
  { setPreSubmit: setPreSubmitAction },
)(PreSubmitInfo);
